var map = {
	"./KnowageBD.png": "dfee",
	"./KnowageER.png": "08d4",
	"./KnowageLI.png": "19cd",
	"./KnowagePA.png": "9570",
	"./KnowagePM.png": "a123",
	"./KnowageSD.png": "5e9c",
	"./KnowageSI.png": "a49b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9f1";